import { ModalHeader, ModalBody, ModalFooter, Label, Input, FormGroup, Form, FormFeedback } from "reactstrap"
import { AddIcon} from "../../../common/icons"
import Select from "../../../common/select/select";
import { useApolloClient } from "@apollo/client";
import { ORG_VALUE_LISTS } from "../../../../graphql/valuelist-gql";
import { IValueListLight } from "../../../../types/valuelist";
import {  useEffect, useState } from "react";
import { IIndividualInput } from "../../../../types/individual";
import { UserRoleType } from "../../../../types/constants";
import AuthWrapper from "../../../common/auth-wrapper";
import Info from "../../../common/info";
import useAuth from "../../../../hook/useAuth";
import { normalizeApostrophes, validEmail } from "../../../../utils/commons";
import Button from "../../../common/button";

interface CreateIndividualDetailProp {
    toggle: () => void;
    onCreate : (individualInput:IIndividualInput) => void;
    createButtonChange: (isContinue: boolean) => void;
}

const CreateIndividualDetail = (prop:CreateIndividualDetailProp) =>{

    const {isAdmin, isCoordinator} = useAuth()
    const {toggle,onCreate,createButtonChange} = prop;
    const client = useApolloClient()
    const { orgValueLists } =  client.readQuery({query: ORG_VALUE_LISTS})
    const [firstnameError,setFirstnameError] = useState<string>('')
    const [lastnameError,setLastnameError] = useState<string>('')
    const [emailError,setEmailError] = useState<string>('')
    const [individualInput,setIndividualInput] = useState<IIndividualInput>(
        {firstName: '',lastName: '',middleName: '',genderId: orgValueLists?.genderTypes[0].id,email: '',honorificId: 0});
    const createDisabled = () => {
        // make sure the first / last names are not just empty spaces
        if (!individualInput.firstName || individualInput.firstName.trim() === '')
            return true;

        if (!individualInput.lastName || individualInput.lastName.trim() === '')
            return true;

        return !individualInput?.genderId || individualInput?.genderId===0 || (isCoordinator && !isAdmin && !individualInput?.email);
    }
    
    useEffect(() => {
        setIndividualInput({firstName: '',lastName: '',middleName: '',genderId: orgValueLists?.genderTypes[0].id,email: '',honorificId: 0})
        setFirstnameError('');
        setLastnameError('');
        setEmailError('');
    },[toggle,orgValueLists])

    useEffect(()=>{
        //console.log("individualInput",individualInput)
        createButtonChange(false)
    },[individualInput])
    /*useEffect(()=>{
        console.log("emailError:",emailError)
    },[emailError])*/
    const onFirstnameChange = (event :any) => {
        if(!event.target.value.trim()) setFirstnameError('First name is required.')
        else setFirstnameError('')
        let correctedFirstName = normalizeApostrophes(event.target.value);
        setIndividualInput({...individualInput,firstName:correctedFirstName.trim()})
    }
    const onLastnameChange = (event :any) => {
        if(!event.target.value.trim()) setLastnameError('Last name is required.')
        else setLastnameError('')
        let correctedLastName = normalizeApostrophes(event.target.value);
        setIndividualInput({...individualInput,lastName:correctedLastName})
    }
    const onMiddlenameChange = (event :any) => {
        let correctedMiddleName = normalizeApostrophes(event.target.value);
        setIndividualInput({...individualInput,middleName:correctedMiddleName})
    }
    const onGenderChange = (event: any) => {setIndividualInput({ ...individualInput, genderId: event.target.value })}
    const onHonorificChange = (event: any) => {setIndividualInput({ ...individualInput, honorificId: event.target.value })}
    const onEmailChange = (event: any) => {
        
        //if(isCoordinator && !isAdmin && !event.target.value.trim()) setEmailError('Email address is required.')
        validateAddressForChange(event.target.value.trim());
        setIndividualInput({ ...individualInput, email: event.target.value.trim() })
    }
    const handleCreate = () => {
        const valid = validateAddressForConfirm(isCoordinator && !isAdmin)
        //console.log("individualInput",individualInput)
        valid && onCreate(individualInput);
        //toggle();

    }

    const validateAddressForChange = (address: string): boolean => {
        
        if (!address || address.length <= 100) {
            setEmailError('')
        } 
        if (address.length > 100) {
            setEmailError("This value is too long. It should have 100 characters or fewer.")
            return false
        } 
        return true
    }

    const validateAddressForConfirm = (inclMandatoryCheck: boolean): boolean => {
        let isValid: boolean = !emailError
        if (isValid ){
            if(inclMandatoryCheck && !individualInput?.email) {
                setEmailError('Email address is required.')
                isValid = false
            } else if (individualInput?.email && !validEmail(individualInput?.email)) {
                setEmailError("Please input a valid email address.")
                return false
            } 
        }
        return isValid
    }

    return (
        <div  style={{backgroundColor:"lightgray"}}>
            <Form>
            <FormGroup>
            <ModalHeader toggle={toggle} tag={'h2'}>Please fill out the information below to create a new individual.</ModalHeader>
            <ModalBody>
                <div className='row' style={{marginBottom:'20px'}}>
                    <Label for="firstname">First Name: (required) </Label>
                    <Input  id= "firstname" placeholder="Enter a first name" onChange={onFirstnameChange} required invalid={!!firstnameError}></Input>
                    <FormFeedback>{firstnameError}</FormFeedback>
                </div>
                <div className='row' style={{marginBottom:'20px'}}>
                    <Label for="lastname">Last Name: (required) </Label>
                    <Input  id= "lastname" placeholder="Enter a last name" onChange={onLastnameChange} required invalid={!!lastnameError}></Input>
                    <FormFeedback>{lastnameError}</FormFeedback>
                </div>
                <div className='row' style={{marginBottom:'20px'}}>
                    <Label for="middlename">Middle Name/Initial: </Label>
                    <Input  id= "middlename" placeholder="Enter a middle name" onChange={onMiddlenameChange}></Input>
                </div>
                <div className='row'>
                    <Label for="gender">Gender: (required) </Label>
                    <Select id="gender" value={individualInput?.genderId} onChange={onGenderChange} required>
                        {orgValueLists.genderTypes.map((item: IValueListLight) => <option key={item.id} value={item.id}>{item.label}</option>)}
                    </Select>
                </div>
                <div className='row'>
                    <Info>Gender is required for translation purposes only.</Info>
                </div>
                <div className='row' style={{marginBottom:'20px'}}>
                    <AuthWrapper role={[UserRoleType.ADMINISTRATOR]}>
                        {(authorized:boolean)=>
                            <>
                            <Label for="email">Email Address: {!authorized && '(required)'}</Label>
                            <Input id= "email" 
                                type="text"
                                value={individualInput?.email} 
                                placeholder="Enter an email address" 
                                onChange={onEmailChange} 
                                invalid={!!emailError}
                                required={!authorized}>
                            </Input>
                            <FormFeedback>{emailError}</FormFeedback>
                            </>
                        }
                    </AuthWrapper>
                </div>
                <div className='row'>
                    <Label for="honorific">Honorific:</Label>
                    <Select id= "honorific" value={individualInput?.honorificId} onChange={onHonorificChange}>
                        <option key={0} value={''}>None </option>
                        {orgValueLists.honorificTitles.map((item: IValueListLight) => <option key={item.id} value={item.id}>{item.label}</option>)}
                    </Select>

                </div>

            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={handleCreate} disabled = {createDisabled()}>
                    <AddIcon/> Create
                </Button>
            </ModalFooter>
            </FormGroup>
            </Form>
        </div>
    )

}

export default CreateIndividualDetail
